export const PARKING_MANAGEMENT_TEMPLATE_PATH = '/resources/Parking_Management_Template.csv'

export const MAX_PARKING_CSV_UPLOAD_FILE_SIZE = 10 * 1024 * 1024 // 10MB
